import axios from 'axios';
import { getLocale } from "./Utils";

declare const API_URL;
declare const kc;
declare const VERSION;

let baseUrl = '';
try {
  baseUrl = API_URL;
} catch (e) {
}

const axiosInstance = axios.create({
  baseURL: baseUrl,
});

export default class RestService {
  static async get(url: string, authenticated = true): Promise<any> {
    const config = {
      headers: await RestService.getHeaders(authenticated),
    };
    const response = await axiosInstance.get(url, config);
    return response.data;
  }

  static async download(url: string, filename, authenticated = true): Promise<any> {
    const config = {
      headers: await RestService.getHeaders(authenticated),
      responseType: 'blob',
    };
    const response = await axiosInstance.get(url, config);
    // create file link in browser's memory
    const href = URL.createObjectURL(response.data);

    // create "a" HTML element with href to file & click
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();

    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link);
  }

  static async post(url: string, data: any = {}): Promise<any> {
    const config = {
      headers: await RestService.getHeaders(),
    };
    const response = await axiosInstance.post(url, data, config);
    return response.data;
  }

  static async put(url: string, data: any = {}): Promise<any> {
    const config = {
      headers: await RestService.getHeaders(),
    };
    const response = await axiosInstance.put(url, data, config);
    return response.data;
  }

  static async delete(url: string): Promise<any> {
    const config = {
      headers: await RestService.getHeaders(),
    };
    const response = await axiosInstance.delete(url, config);
    return response.data;
  }

  private static async getHeaders(authenticated = true) {
    const headers: any = {
      'client-langcode': getLocale(),
      'client-hostname': window.location.hostname,
      'client-version': VERSION,
    };
    if (authenticated) {
      await kc.updateToken(30);
      headers.token = kc.token;
    }
    return headers;
  }
}
